import React from 'react';
import {
  InputLabel as MuiInputLabel,
  type InputLabelProps,
} from '@mui/material';

export type { InputLabelProps };

export default function InputLabel({ children, ...props }: InputLabelProps) {
  return <MuiInputLabel {...props}>{children}</MuiInputLabel>;
}
